/* eslint-disable prettier/prettier */
import React from "react";
import dynamic from "next/dynamic";
import PropTypes from "prop-types";
const Icon = dynamic(() => import("@/bit/components/components.icon-glyph"));

/**
 * Componente que define las propiedades de contrato de una card
 */
const CmsHiringDetails = (props) => {
  const { cmsHandler } = props;

  if (cmsHandler) {
    return (
      <span
        className={
          "element-editable block edit-component cms-hiring-placeholder"
        }
        onClick={() =>
          cmsHandler({
            ...props,
            name: "cms-block.cms-hiring-details",
          })
        }
      >
        <Icon id="configuracion-m" width={28} color="white"/>
      </span>
    );
  }
  return <></>;
};

CmsHiringDetails.propTypes = {
  /**
   * {
   *  "info": "Categoria de la card para poder filtrar",
   *  "kind": "both",
   *  "beautifulName": "Categoria"
   * }
   */
  category: PropTypes.string,
  /**
   * {
   *  "info": "Subcategoria de la card para poder filtrar",
   *  "kind": "both",
   *  "beautifulName": "Subcategoria"
   * }
   */
  subcategory: PropTypes.string,
  /**
   * {
   *  "info": "Product Offering",
   *  "kind": "both",
   *  "beautifulName": "Product Offering"
   * }
   */
  po: PropTypes.string,
  /**
   * {
   *  "info": "JSON para crear reglas",
   *  "kind": "both",
   *  "beautifulName": "Visible si cumple:"
   * }
   */
  "cms-json-rules-1": PropTypes.string,
};

CmsHiringDetails.defaultProps = {
  category: "todos,",
  subcategory: "todos,",
  po: "",
  "cms-json-rules-1": "{}",
};

export default CmsHiringDetails;
